import React from "react";
import { BackButton } from "@deliverr/ui-facility/lib-facility/components/buttons/common/facilityCommonsButtons";
import { useCrossdockDimsAndWeightBackToProductDims } from "crossdock/modes/inspection/crossdock-dims-and-weight/buttons/backToProductDims/useCrossdockDimsAndWeightBackToProductDims";

export const CrossdockDimsAndWeightBackToProductDimsButton: React.FC = () => {
  const { onClick } = useCrossdockDimsAndWeightBackToProductDims();

  return <BackButton onClick={onClick} secondary block />;
};
